import * as React from 'react';
import * as Scroll from 'react-scroll';
import translate from '../../locale/translate';

import HeaderLink from './HeaderLink';

interface IProps {
}

export default class Header extends React.Component<IProps, void> {
    static propTypes = {
        children: React.PropTypes.any
    };

    scroll = Scroll.animateScroll;

    render() {
        let { children } = this.props;

        return (
            <nav className="navbar navbar-inverse navbar-fixed-top">
                <div className="container-fluid">
                    <div className="navbar-header initial" style={{ width: '19%' }}>
                        <a className="navbar-brand" onClick={() => this.scroll.scrollToTop()}>{translate.gettext("Report Editor")}</a>
                    </div>
                    <div id="navbar" className="navbar-collapse collapse">
                        {children}
                    </div>
                </div>
            </nav>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/header/Header.tsx